var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playbook-rules"},[_c('div',{staticClass:"playbook-rules__heading"},[_vm._v("Personalization Rules Used:")]),_vm._l((_vm.rules),function(slug){return _c('playbooks-card-rule',{key:slug,attrs:{"slug":slug}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }